function cta(data) {
    if (data === '') {
        const markup = `<div class="card__cta card__cta--button">
        <p class="card__cta-text">Read Article</p>
    </div>`

        return markup
    } else {
        return `
        <div class="card__cta card__cta--media">
        <span class="card__cta-icon">
            <svg width="8" height="8">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#icon_play"></use>
            </svg>
        </span>
        <div>
            <p class="card__cta-text">Watch Video</p>
            <time datetime="" class="card__cta-time card__cta-time--dark">${data}</time>
        </div>
    </div>`
    }
}

const template = (data) => `
    <div class="grid__item">
        <article class="card card--article ${data.accent}">
            <a href="${data.url}" class="card__link">
                <div class="card__shape-container">
                    <div class="card__shape"></div>
                    <div class="card__image-container">
                        ${data.image?.src ? `<img class="card__image" src="${data.image?.src}" alt="${data.image?.alt}"  />` : ''}
                    </div>
                </div>
                <div class="card__container card__container--restrict-psuedo">
                    <div>
                        ${data.tag ? `<span class="tag">${data.tag}</span>` : ''}
                        ${data.title ? `<h3 class="card__heading">${data.title}</h3>` : ''}
                        <time class="card__description" datetime="${data.dateTime}">${data.date}</time>
                    </div>
                    ${cta(data.videoDuration)}
                </div>
            </a>
        </article>
    </div>
`
export default template
